<template>
  <div class="login-page">
    <div class="login-background"></div>
    
    <div class="login-container">
      <!-- Asosiy login kartasi -->
      <div class="login-card">
        <div class="card-header">
          <div class="logo">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
              <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>AvtoTesting</span>
          </div>
          <h1>Kirish</h1>
          <p>Davom etish uchun hisobingizga kiring</p>
        </div>

        <!-- Xatolik -->
        <div v-if="error" class="error-message">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          {{ error }}
        </div>

        <!-- Premium talab qilinsa -->
        <div v-if="requiresPremium" class="premium-required">
          <div class="premium-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M12 2L15 8.5L22 9.5L17 14L18.5 21L12 17.5L5.5 21L7 14L2 9.5L9 8.5L12 2Z"/>
            </svg>
          </div>
          <h3>Premium obuna talab qilinadi</h3>
          <p>Testlarni yechish va natijalarni ko'rish uchun premium obuna sotib oling</p>
          <button class="premium-button" @click="goToPremium">
            Premium olish
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="5" y1="12" x2="19" y2="12"/>
              <polyline points="12 5 19 12 12 19"/>
            </svg>
          </button>
        </div>

        <!-- Login form -->
        <form v-else @submit.prevent="handleSubmit" class="login-form">
          <div class="input-group">
            <label>Telefon raqam</label>
            <div class="phone-input">
              <span class="country-code">+998</span>
              <input
                type="tel"
                v-model="phoneNumber"
                placeholder="90 123 45 67"
                @input="formatPhone"
                :class="{ 'has-error': phoneError }"
              />
            </div>
            <span v-if="phoneError" class="input-error">{{ phoneError }}</span>
            <span v-if="detectedOperator" class="operator-badge">{{ detectedOperator }}</span>
          </div>

          <div class="input-group">
            <label>Parol</label>
            <div class="password-input">
              <input
                :type="showPassword ? 'text' : 'password'"
                v-model="password"
                placeholder="Parolingizni kiriting"
                @keyup.enter="handleSubmit"
              />
              <button type="button" class="toggle-password" @click="showPassword = !showPassword">
                <svg v-if="!showPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
                <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                  <line x1="1" y1="1" x2="23" y2="23"/>
                </svg>
              </button>
            </div>
          </div>

          <div class="form-footer">
            <label class="remember-me">
              <input type="checkbox" v-model="rememberMe" />
              <span>Eslab qolish</span>
            </label>
            <button type="button" class="forgot-link" @click="handleForgotPassword">
              Parolni unutdingiz?
            </button>
          </div>

          <button type="submit" class="login-button" :disabled="loading">
            <span v-if="loading" class="spinner"></span>
            <span v-else>Kirish</span>
          </button>

          <div class="divider">
            <span>yoki</span>
          </div>

          <button type="button" class="telegram-button" @click="handleTelegramRegister">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.66-.35-1.02.22-1.61.15-.15 2.71-2.48 2.76-2.69.01-.03.02-.14-.05-.2-.07-.06-.18-.04-.26-.02-.11.02-1.86 1.18-5.26 3.48-.5.34-.95.51-1.36.5-.45-.01-1.31-.25-1.95-.46-.84-.28-1.51-.43-1.45-.91.03-.25.38-.51 1.07-.78 4.2-1.83 7-3.03 8.4-3.61 4-1.66 4.83-1.95 5.37-1.96.12 0 .38.03.55.18.14.12.18.28.2.44-.01.13-.03.27-.05.41z"/>
            </svg>
            Telegram orqali
          </button>

          <p class="register-prompt">
            Hisobingiz yo'qmi?
            <button type="button" class="register-link" @click="handleTelegramRegister">
              Ro'yxatdan o'tish
            </button>
          </p>
        </form>
      </div>
    </div>

    <!-- Telegram modal - @smartypx_bot uchun -->
    <div v-if="telegramModalVisible" class="modal-overlay" @click="telegramModalVisible = false">
      <div class="modal-content" @click.stop>
        <button class="modal-close" @click="telegramModalVisible = false">×</button>
        
        <div class="modal-header">
          <div class="telegram-logo">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.66-.35-1.02.22-1.61.15-.15 2.71-2.48 2.76-2.69.01-.03.02-.14-.05-.2-.07-.06-.18-.04-.26-.02-.11.02-1.86 1.18-5.26 3.48-.5.34-.95.51-1.36.5-.45-.01-1.31-.25-1.95-.46-.84-.28-1.51-.43-1.45-.91.03-.25.38-.51 1.07-.78 4.2-1.83 7-3.03 8.4-3.61 4-1.66 4.83-1.95 5.37-1.96.12 0 .38.03.55.18.14.12.18.28.2.44-.01.13-.03.27-.05.41z"/>
            </svg>
          </div>
          <h3>{{ telegramModalTitle }}</h3>
          <p>{{ telegramModalMessage }}</p>
        </div>

        <!-- QR kod va bot linki -->
        <div class="qr-code">
          <img :src="qrCodeUrl" alt="QR Code" />
        </div>

        <div class="steps">
          <div class="step">
            <span class="step-number">1</span>
            <span>Telegram'ni oching</span>
          </div>
          <div class="step">
            <span class="step-number">2</span>
            <span>@smartypx_bot ni qidiring</span>
          </div>
          <div class="step">
            <span class="step-number">3</span>
            <span>"Start" tugmasini bosing</span>
          </div>
          <div class="step" v-if="telegramAction === 'reset'">
            <span class="step-number">4</span>
            <span>Parolni tiklash uchun "Parolni tiklash" ni tanlang</span>
          </div>
          <div class="step" v-else-if="telegramAction === 'register'">
            <span class="step-number">4</span>
            <span>Ro'yxatdan o'tish uchun "Ro'yxatdan o'tish" ni tanlang</span>
          </div>
        </div>

        <a 
          :href="telegramBotLink"
          target="_blank"
          class="telegram-open-btn"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.66-.35-1.02.22-1.61.15-.15 2.71-2.48 2.76-2.69.01-.03.02-.14-.05-.2-.07-.06-.18-.04-.26-.02-.11.02-1.86 1.18-5.26 3.48-.5.34-.95.51-1.36.5-.45-.01-1.31-.25-1.95-.46-.84-.28-1.51-.43-1.45-.91.03-.25.38-.51 1.07-.78 4.2-1.83 7-3.03 8.4-3.61 4-1.66 4.83-1.95 5.37-1.96.12 0 .38.03.55.18.14.12.18.28.2.44-.01.13-.03.27-.05.41z"/>
          </svg>
          Telegram'ni ochish
        </a>
        
        <div class="bot-note">
          <span>🤖 Bot: @smartypx_bot</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginPage',
  data() {
    return {
      phoneNumber: '',
      password: '',
      rememberMe: false,
      showPassword: false,
      loading: false,
      error: '',
      requiresPremium: false,
      phoneError: '',
      telegramModalVisible: false,
      telegramAction: 'login', // 'register', 'reset', 'login'
      telegramBotUsername: 'smartypx_bot'
    }
  },
  computed: {
    fullPhone() {
      if (!this.phoneNumber) return ''
      const clean = this.phoneNumber.replace(/\D/g, '')
      if (clean.length === 0) return ''
      return `+998${clean}`
    },
    detectedOperator() {
      const clean = this.phoneNumber.replace(/\D/g, '')
      if (clean.length < 2) return ''
      
      const code = clean.substring(0, 2)
      const operators = {
        '90': 'Beeline', '91': 'Beeline',
        '93': 'Ucell', '94': 'Ucell',
        '95': 'Uzmobile', '99': 'Uzmobile',
        '97': 'MobiUz', '88': 'MobiUz',
        '98': 'Perfectum', '33': 'Humans'
      }
      return operators[code] || ''
    },
    telegramModalTitle() {
      if (this.telegramAction === 'register') {
        return 'Ro\'yxatdan o\'tish'
      } else if (this.telegramAction === 'reset') {
        return 'Parolni tiklash'
      }
      return 'Telegram orqali kirish'
    },
    telegramModalMessage() {
      if (this.telegramAction === 'register') {
        return 'Bot orqali ro\'yxatdan o\'ting va hisobingizni faollashtiring'
      } else if (this.telegramAction === 'reset') {
        return 'Bot orqali parolingizni tiklang'
      }
      return 'Botga start bosib tizimga kiring'
    },
    telegramBotLink() {
      return `https://t.me/${this.telegramBotUsername}`
    },
    qrCodeUrl() {
      // QR kodda faqat bot linki ko'rsatiladi, start parametri ishlatilmaydi
      // chunki bot start bosganda menyu ko'rsatadi
      return `https://api.qrserver.com/v1/create-qr-code/?size=160x160&data=${encodeURIComponent(this.telegramBotLink)}`
    }
  },
  methods: {
    formatPhone(e) {
      let value = e.target.value.replace(/\D/g, '')
      if (value.length > 9) value = value.slice(0, 9)
      
      let formatted = ''
      if (value.length > 0) {
        formatted += value.slice(0, 2)
        if (value.length > 2) {
          formatted += ' ' + value.slice(2, 5)
        }
        if (value.length > 5) {
          formatted += ' ' + value.slice(5, 7)
        }
        if (value.length > 7) {
          formatted += ' ' + value.slice(7, 9)
        }
      }
      this.phoneNumber = formatted
      this.validatePhone()
    },
    validatePhone() {
      const clean = this.phoneNumber.replace(/\D/g, '')
      if (clean.length === 0) {
        this.phoneError = ''
        return true
      }
      if (clean.length !== 9) {
        this.phoneError = 'Telefon raqam 9 raqamdan iborat bo\'lishi kerak'
        return false
      }
      const code = clean.substring(0, 2)
      const validCodes = ['90', '91', '93', '94', '95', '97', '98', '99', '33', '88']
      if (!validCodes.includes(code)) {
        this.phoneError = 'Noto\'g\'ri operator kodi'
        return false
      }
      this.phoneError = ''
      return true
    },
    async handleSubmit() {
      if (!this.validatePhone()) return
      if (!this.password) {
        this.error = 'Parolni kiriting'
        return
      }
      
      this.loading = true
      this.error = ''
      this.requiresPremium = false
      
      try {
        const response = await this.$store.dispatch('auth/login', {
          phone: this.fullPhone,
          password: this.password
        })
        
        if (response?.requires_premium) {
          this.requiresPremium = true
          return
        }
        
        this.$message.success('Muvaffaqiyatli kirdingiz')
        this.$router.push('/')
      } catch (err) {
        if (err?.requires_premium) {
          this.requiresPremium = true
        } else {
          this.error = err?.detail || 'Telefon yoki parol noto\'g\'ri'
        }
      } finally {
        this.loading = false
      }
    },
    goToPremium() {
      this.$router.push('/premium')
    },
    // Ro'yxatdan o'tish - Telegram botga yo'naltirish
    handleTelegramRegister() {
      this.telegramAction = 'register'
      this.telegramModalVisible = true
    },
    // Parolni tiklash - Telegram botga yo'naltirish
    handleForgotPassword() {
      this.telegramAction = 'reset'
      this.telegramModalVisible = true
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.login-background {
  position: fixed;
  inset: 0;
  background: radial-gradient(circle at 20% 40%, rgba(255,255,255,0.1) 0%, transparent 50%);
  pointer-events: none;
}

.login-container {
  width: 100%;
  max-width: 460px;
}

.login-card {
  background: white;
  border-radius: 24px;
  padding: 40px 32px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  animation: slideUp 0.5s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card-header {
  text-align: center;
  margin-bottom: 32px;
}

.logo {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  padding: 8px 16px;
  border-radius: 40px;
  margin-bottom: 24px;
}

.logo svg {
  width: 24px;
  height: 24px;
  color: white;
}

.logo span {
  font-size: 18px;
  font-weight: 600;
  color: white;
}

.card-header h1 {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 8px 0;
}

.card-header p {
  font-size: 14px;
  color: #666;
  margin: 0;
}

/* Error message */
.error-message {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #fee2e2;
  border: 1px solid #fecaca;
  border-radius: 12px;
  color: #dc2626;
  font-size: 14px;
  margin-bottom: 24px;
}

.error-message svg {
  flex-shrink: 0;
}

/* Premium required */
.premium-required {
  text-align: center;
  padding: 32px 0;
}

.premium-icon {
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #fbbf24, #f59e0b);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.premium-icon svg {
  color: white;
  width: 32px;
  height: 32px;
}

.premium-required h3 {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0 0 8px 0;
}

.premium-required p {
  font-size: 14px;
  color: #666;
  margin: 0 0 24px 0;
}

.premium-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: linear-gradient(135deg, #fbbf24, #f59e0b);
  border: none;
  border-radius: 40px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.premium-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(245, 158, 11, 0.3);
}

/* Form */
.login-form {
  margin-top: 8px;
}

.input-group {
  margin-bottom: 20px;
}

.input-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #1a1a2e;
  margin-bottom: 8px;
}

.phone-input {
  display: flex;
  align-items: center;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
  transition: all 0.2s;
}

.phone-input:focus-within {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.country-code {
  padding: 12px 0 12px 16px;
  font-size: 16px;
  font-weight: 500;
  color: #1a1a2e;
  background: #f1f5f9;
  border-right: 1px solid #e2e8f0;
  border-radius: 12px 0 0 12px;
}

.phone-input input,
.password-input input {
  flex: 1;
  padding: 12px 16px;
  border: none;
  background: transparent;
  font-size: 16px;
  outline: none;
  color: #1a1a2e;
}

.phone-input input::placeholder,
.password-input input::placeholder {
  color: #94a3b8;
}

.phone-input.has-error {
  border-color: #dc2626;
}

.input-error {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: #dc2626;
}

.operator-badge {
  display: inline-block;
  margin-top: 6px;
  padding: 2px 8px;
  background: #e6f7e6;
  color: #10b981;
  font-size: 11px;
  font-weight: 500;
  border-radius: 20px;
}

.password-input {
  display: flex;
  align-items: center;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
  transition: all 0.2s;
}

.password-input:focus-within {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.toggle-password {
  padding: 0 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #94a3b8;
}

.toggle-password:hover {
  color: #667eea;
}

.form-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.remember-me {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.remember-me input {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.remember-me span {
  font-size: 14px;
  color: #666;
}

.forgot-link {
  background: none;
  border: none;
  font-size: 14px;
  color: #667eea;
  cursor: pointer;
  transition: color 0.2s;
}

.forgot-link:hover {
  color: #764ba2;
}

.login-button {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border: none;
  border-radius: 12px;
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.login-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
}

.login-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.divider {
  position: relative;
  text-align: center;
  margin: 24px 0;
}

.divider::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background: #e2e8f0;
}

.divider span {
  position: relative;
  background: white;
  padding: 0 16px;
  font-size: 14px;
  color: #94a3b8;
}

.telegram-button {
  width: 100%;
  padding: 12px;
  background: #0088cc;
  border: none;
  border-radius: 12px;
  color: white;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: background 0.2s;
}

.telegram-button:hover {
  background: #0077b3;
}

.register-prompt {
  text-align: center;
  margin-top: 24px;
  font-size: 14px;
  color: #666;
}

.register-link {
  background: none;
  border: none;
  color: #667eea;
  font-weight: 600;
  cursor: pointer;
  margin-left: 4px;
}

.register-link:hover {
  color: #764ba2;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.modal-content {
  background: white;
  border-radius: 24px;
  padding: 32px;
  max-width: 400px;
  width: 90%;
  position: relative;
  animation: slideUp 0.3s ease;
}

.modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #f1f5f9;
  border: none;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  transition: all 0.2s;
}

.modal-close:hover {
  background: #e2e8f0;
}

.modal-header {
  text-align: center;
  margin-bottom: 24px;
}

.telegram-logo {
  width: 56px;
  height: 56px;
  background: #0088cc;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
}

.telegram-logo svg {
  color: white;
  width: 28px;
  height: 28px;
}

.modal-header h3 {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0 0 8px 0;
}

.modal-header p {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.qr-code {
  display: flex;
  justify-content: center;
  margin: 24px 0;
  padding: 16px;
  background: #f8fafc;
  border-radius: 16px;
}

.qr-code img {
  width: 160px;
  height: 160px;
}

.steps {
  margin: 24px 0;
}

.step {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
}

.step:not(:last-child) {
  border-bottom: 1px solid #e2e8f0;
}

.step-number {
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}

.step span:last-child {
  font-size: 14px;
  color: #1a1a2e;
}

.telegram-open-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px;
  background: #0088cc;
  border-radius: 12px;
  color: white;
  text-decoration: none;
  font-weight: 600;
  transition: background 0.2s;
  margin-top: 8px;
}

.telegram-open-btn:hover {
  background: #0077b3;
  color: white;
}

.bot-note {
  text-align: center;
  margin-top: 16px;
  font-size: 12px;
  color: #94a3b8;
}

/* Responsive */
@media (max-width: 480px) {
  .login-card {
    padding: 32px 24px;
  }
  
  .card-header h1 {
    font-size: 24px;
  }
  
  .phone-input input,
  .password-input input {
    font-size: 14px;
  }
}
</style>